function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module enter/entercommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { getCopyOnEnterAttributes } from './utils';
/**
 * Enter command. It is used by the {@link module:enter/enter~Enter Enter feature} to handle the <kbd>Enter</kbd> key.
 *
 * @extends module:core/command~Command
 */

var EnterCommand = /*#__PURE__*/function (_Command) {
  _inherits(EnterCommand, _Command);

  var _super = _createSuper(EnterCommand);

  function EnterCommand() {
    _classCallCheck(this, EnterCommand);

    return _super.apply(this, arguments);
  }

  _createClass(EnterCommand, [{
    key: "execute",
    value:
    /**
     * @inheritDoc
     */
    function execute() {
      var _this = this;

      var model = this.editor.model;
      var doc = model.document;
      model.change(function (writer) {
        enterBlock(_this.editor.model, writer, doc.selection, model.schema);

        _this.fire('afterExecute', {
          writer: writer
        });
      });
    }
  }]);

  return EnterCommand;
}(Command); // Creates a new block in the way that the <kbd>Enter</kbd> key is expected to work.
//
// @param {module:engine/model~Model} model
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
// Selection on which the action should be performed.
// @param {module:engine/model/schema~Schema} schema


export { EnterCommand as default };

function enterBlock(model, writer, selection, schema) {
  var isSelectionEmpty = selection.isCollapsed;
  var range = selection.getFirstRange();
  var startElement = range.start.parent;
  var endElement = range.end.parent; // Don't touch the roots and other limit elements.

  if (schema.isLimit(startElement) || schema.isLimit(endElement)) {
    // Delete the selected content but only if inside a single limit element.
    // Abort, when crossing limit elements boundary (e.g. <limit1>x[x</limit1>donttouchme<limit2>y]y</limit2>).
    // This is an edge case and it's hard to tell what should actually happen because such a selection
    // is not entirely valid.
    if (!isSelectionEmpty && startElement == endElement) {
      model.deleteContent(selection);
    }

    return;
  }

  if (isSelectionEmpty) {
    var attributesToCopy = getCopyOnEnterAttributes(writer.model.schema, selection.getAttributes());
    splitBlock(writer, range.start);
    writer.setSelectionAttribute(attributesToCopy);
  } else {
    var leaveUnmerged = !(range.start.isAtStart && range.end.isAtEnd);
    var isContainedWithinOneElement = startElement == endElement;
    model.deleteContent(selection, {
      leaveUnmerged: leaveUnmerged
    });

    if (leaveUnmerged) {
      // Partially selected elements.
      //
      // <h>x[xx]x</h>		-> <h>x^x</h>			-> <h>x</h><h>^x</h>
      if (isContainedWithinOneElement) {
        splitBlock(writer, selection.focus);
      } // Selection over multiple elements.
      //
      // <h>x[x</h><p>y]y<p>	-> <h>x^</h><p>y</p>	-> <h>x</h><p>^y</p>
      else {
          writer.setSelection(endElement, 0);
        }
    }
  }
}

function splitBlock(writer, splitPos) {
  writer.split(splitPos);
  writer.setSelection(splitPos.parent.nextSibling, 0);
}